import React from 'react';
import { ListItemButton, ListItemText } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useUntypedTranslation } from '../../../hooks/useUntypedTranslation';
import {
  row,
  rowText,
  rowTitleQuiet,
  meta,
  focusRing,
  pressable,
} from '../../../styles/visualLanguage';

/**
 * NewEngagementRow
 *
 * The always-present "begin a new engagement" CTA, retrofitted onto the
 * prototype's `.eng-item.ghost` treatment: no icon, a quiet ink-3/weight-400
 * title shifting to ink-2 on hover, its subtitle line kept (the ghost row
 * does carry a `.m` line, `flow-app.js:112-115`). Owns its own navigation
 * call, matching this repo's convention (no component here takes a
 * navigation callback prop). Navigates to the intake screen at
 * `/advisory/new`, where the fresh client-side engagement id is minted on
 * submit instead — this row itself mints nothing.
 *
 * Deliberately takes no read-channel prop and contains no conditional that
 * could hide it — this CTA must stay independent of the read channel. A
 * gated CTA here would remove the only available action in exactly the
 * denied environment every deployed environment is in currently. Do not
 * add a read-channel-derived gate to this component.
 */
export function NewEngagementRow() {
  const navigate = useNavigate();
  const { t } = useUntypedTranslation();

  const handleClick = () => {
    navigate('/advisory/new');
  };

  return (
    <ListItemButton
      onClick={handleClick}
      disableRipple
      disableGutters
      sx={[row, focusRing, pressable]}
    >
      <ListItemText
        primary={t('advisory:list.cta.title')}
        primaryTypographyProps={{ variant: 'body1', sx: [rowTitleQuiet] }}
        sx={[rowText]}
        secondary={t('advisory:list.cta.subtitle')}
        secondaryTypographyProps={{ variant: 'body2', sx: [meta] }}
      />
    </ListItemButton>
  );
}

export default NewEngagementRow;
